import React from 'react';
import { Table, Numbers } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

const HomeTab = ({ currency, locale, data }) => {
    const { t } = useTranslation();
    let counter = 0;
    return (
        <Table useNew>
            <Table.THead>
                <Table.Tr>
                    <th>{t('ticket.ticket_office_home.thead.fst_clmn')}</th>
                    <th>{t('ticket.ticket_office_home.thead.snd_clmn')}</th>
                    <th>{t('ticket.ticket_office_home.thead.thd_clmn')}</th>
                    <th>{t('ticket.ticket_office_home.thead.frh_clmn')}</th>
                </Table.Tr>
            </Table.THead>
            <Table.TBody>
                {/* We only want to have the first 5 elements for preview */}
                {data.map(element => {
                    counter++;
                    let turnover = element.sum - element.sum_refund;
                    return (
                        counter <= 5 && (
                            <Table.Tr>
                                <Table.Td>{element.event_name}</Table.Td>
                                <Table.Td>
                                    {element.count} {t('ticket.ticket_office_home.tab_body.ticket', { count: Number(element.count) })}
                                </Table.Td>
                                <Table.Td>
                                    {element.count_refund} {t('ticket.ticket_office_home.tab_body.ticket', { count: Number(element.count) })}
                                </Table.Td>
                                <Table.Td>
                                    <Numbers value={turnover} locale={locale} currency={currency} showNullDecimal />
                                </Table.Td>
                            </Table.Tr>
                        )
                    );
                })}
            </Table.TBody>
        </Table>
    );
};

export default HomeTab;
